<template>
  <div>
    <div class="agenda-item"
         @click.capture="handleClickWholeItem"
         @click="handleAgendaCardClick"
         :class="{hideDateForMobile: groupTimeFrame, 'agenda-item--clickable': session.is_agenda}">

      <div class="agenda-item__header">
        <div>
          <time class="agenda-item__time">
            <i class="fa-regular fa-clock"></i> {{ session.period_formatted }}
          </time> &nbsp; &nbsp;

          <marked-status style="font-weight: 400" class="desktop-only" icon="fa-location-dot" v-if="session?.room?.name">{{ session.room.name }}</marked-status>
        </div>
        <div>


        <span v-show="session.buttons?.evaluation?.completed" class="agenda-item__status mobile-only">
            <colored-status color="green">Completed</colored-status>
          </span>

        <span v-show="session.buttons?.evaluation?.quiz?.is_failed" class="agenda-item__status">
            <colored-status color="#e2544d">Quiz Failed</colored-status>
          </span>

        <span  class="agenda-item__status">
            <colored-status color="#e2544d" v-show="session.in_progress">In Progress</colored-status>
          </span>

        <span @click.stop="" v-tooltip="sessionStatuses.NOT_REGISTERED">
            <i class="fa-regular fa-lock-keyhole" style="color: purple;" v-show="session.not_registered_for && !session.is_agenda"></i>
        </span>
        </div>
      </div>

      <div class="agenda-item__body">
        <h4 class="agenda-item__title">
          <router-link v-if="!session.is_agenda" :to="{path: `/${attendeeId}/dash/agenda/sessions/${session.id}`, query: {back: currentPage}}">
            <div
                v-if="session.tracks?.length"
                class="agenda-mobile-track"
                :style="`background: ${session.tracks[0].color}`"
            ></div>
            {{ session.name }}
          </router-link>

          <button
            v-if="session.is_agenda"
            type="button"
            class="agenda-item__title-button font-weight-600"
            @click="isAgendaInfoOpen = true"
          >{{ session.name }}</button>

          <div class="agenda-scheduler-buttons-mobile" :class="{'up-if-no-status': noAnyStatus}" v-if="!hiddenScheduleButton">
            <agenda-schedule-buttons-mobile
              v-if="allowAddToScheduler"
              :show-scheduler-indicator="showSchedulerIndicator"
              :enabled="session.buttons?.my_schedule?.enabled"
              :completed="session.buttons?.my_schedule?.completed"
              :can-delete="session.buttons?.my_schedule?.can_delete"
              @updateScheduler="updateScheduler"
            />
          </div>
        </h4>

        <div class="agenda-item__short-description"  v-if="session.my_presentations && !!session.my_scheduled_count">
          {{session.my_scheduled_count}} attendee(s) have added this session to their schedule
        </div>

        <!-- Hours -->
        <div
          v-if="!session.is_agenda && !(!session.is_educational && +session.credit_hours === 0)"
          class="agenda-item-info-item"
          :class="{showCEOnMobile: showCeHoursOnMobile}"
        >
          <strong>{{ session.is_educational ? 'CE' : '' }} Hours:</strong>
          {{ session.credit_hours }} &nbsp;

          <!-- topics -->
          <span key="topics"  v-if="session.topics?.length" v-for="(topic, topicIndex) in session.topics" :key="`topic-${topicIndex}`">
            <marked-status
              style="margin-bottom: 7px;"
              :withBorder="true"
              :icon="topic.icon"
            >{{ topic.title }} <span v-if="topic.hours">({{ topic.hours }})</span></marked-status>&nbsp;
          </span>
        </div>


        <div class="agenda-mobile-line"></div>

        <div class="agenda-item__info" :key="`session-${session.id}`">

          <!-- approved -->
          <agenda-approvals
              v-if="session.is_educational"
              color="rgb(1 128 1)"
              icon="fa-shield-check"
              type="approved"
              :hide-additional-board-approvals="true"
              :approvals="session?.approvals?.approved"
          />

          <!-- pending -->
          <agenda-approvals
              v-if="session.is_educational"
              color="rgb(255, 176, 66)"
              icon="fa-shield-exclamation"
              type="pending"
              :approvals="session?.approvals?.pending"
          />
          <!-- not_approved -->
          <agenda-approvals
              v-if="session.is_educational"
              color="rgb(255, 102, 102)"
              icon="fa-solid fa-shield-xmark"
              type="not_approved"
              :approvals="session?.approvals?.not_approved"
          />

          <!-- room -->
<!--          <div  class="agenda-item-info-item" key="room">-->
<!--            <i class="fa-solid fa-person-booth"></i><strong>Room:</strong>-->
<!--            <span>-->
<!--           -->
<!--            </span>-->
<!--          </div>-->

          <!-- tracks -->
          <div v-if="session.tracks?.length" class="agenda-item-info-item" key="tracks">
            <strong>Tracks:</strong>
            <span v-for="(track, trackIndex) in session.tracks" :key="`track-${trackIndex}`">
              <marked-status
                  :marker-color="track.color"
              >{{ track.name }}</marked-status>&nbsp;
            </span>
          </div>

          <div v-if="session?.format && !session.is_agenda" class="agenda-item-info-item" key="room">
            <strong>Format:</strong>
            <span style="text-transform: capitalize;">
              <marked-status>{{ session.format }}</marked-status>
            </span>
          </div>

          <!-- description -->
          <div class="agenda-item__description">
            {{ limitTo(session.description, 300) }}
          </div>

          <speakers-short-list
              :presenters="session.presenters"
              :per-page-custom="[[768, 1],[1200, 2], [1500, 3]]"
          />
        </div>

        <div class="agenda-footer" :class="{'agenda-footer--single-session': this.attendee?.conference?.is_single_session}">

          <div class="agenda-footer__wrapper">
            <div class="agenda-footer__button" v-if="!hiddenScheduleButton">
              <agenda-scheduler-buttons
                v-if="allowAddToScheduler"
                :show-scheduler-indicator="showSchedulerIndicator"
                :enabled="session.buttons?.my_schedule?.enabled"
                :completed="session.buttons?.my_schedule?.completed"
                :can-delete="session.buttons?.my_schedule?.can_delete"
                @updateScheduler="updateScheduler"
              />

              <div v-if="co_occurring">
                <co-occurring-modal :sessions="co_occurring.sessions" :title="co_occurring.flash" @close="co_occurring = null" @agree="updateScheduler({agree: true})"/>
              </div>
            </div>

            <div v-if="session.buttons?.discussion?.enabled" class="agenda-footer__button">
              <c-button
                  uppercase
                  fill
                  icon="fa-solid fa-comments"
                  theme="purple"
                  size="sm"
                  :href="`${session.buttons?.discussion?.link}&attendeeId=${attendeeId}`"
              >
                Discussion
              </c-button>
            </div>
          </div>


          <div class="agenda-footer__wrapper">
            <div v-if="session.buttons?.virtual_session?.enabled" class="agenda-footer__button">
              <c-button
                  fill
                  uppercase
                  icon="fa-solid fa-network-wired"
                  theme="success"
                  size="sm"
                  :href="session.buttons?.virtual_session?.link"
                  target="_blank"
              >
                Join Virtual Session
              </c-button>
            </div>

            <div
                v-if="(session.buttons?.evaluation?.enabled && session.buttons?.evaluation?.available) || NOT_MEET"
                class="agenda-footer__button agenda-footer__button--badged"
            >
              <c-button
                uppercase
                fill
                theme="primary"
                size="sm"
                icon="fa-solid fa-comments-question"
                @click="goTo('evaluation', session.id)"
                :disabled="NOT_MEET || EVALUATION_EXPIRED"
                v-tooltip='{content: sessionStatuses.NOT_MEET_THRESHOLD, visible: NOT_MEET}'
              >
                {{session.buttons?.evaluation?.button_name || 'Start Evaluation'}}
              </c-button>

              <span
                  v-if="EVALUATION_EXPIRATION_DATE && !NOT_MEET"
                  class="eval-expiration-badge"
                  v-tooltip="expirationBadgeTooltip"
              >?</span>
            </div>
            <div class="agenda-footer__button">
              <c-button
                v-if="session.buttons?.evaluation?.completed"
                uppercase
                fill
                theme="success"
                size="sm"
                icon="fa-solid fa-comments-question"
              >Evaluation Completed</c-button>
            </div>

            <div
                v-if="(
                session.buttons?.evaluation?.quiz?.enabled
                && !session.buttons?.evaluation?.quiz?.completed
                && !session.buttons?.evaluation?.quiz?.is_failed)"
                class="agenda-footer__button"
            >
              <c-button
                uppercase
                fill
                theme="warning"
                icon="fa-solid fa-ballot-check"
                size="sm"
                @click="goTo('quiz',session.id)"
                :disabled="NOT_MEET"
                v-tooltip='{content: sessionStatuses.NOT_MEET_THRESHOLD, visible: NOT_MEET}'
              >
                Start Quiz
              </c-button>
            </div>

            <div class="agenda-footer__button">
              <agenda-attended-buttons
                  :completed="session.buttons?.attended_session?.completed"
                  :enabled="session.buttons?.attended_session?.enabled"
                  :is-overlap="session.buttons?.attended_session?.is_overlap"
                  :attendee-id="attendeeId"
                  :session-id="session.id"
                  :code="session.buttons?.evaluation?.code"
              />
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Outside .agenda-item so clicks inside the modal don't reach the card handler and reopen it -->
    <agenda-info-modal
      v-if="session.is_agenda"
      :show-modal.sync="isAgendaInfoOpen"
      :session="session"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { limitTo } from "../../../helpers/limitTo";
import agendaAPI from "../../../api/agendaAPI";
import AgendaApprovals from "./agenda-approvals";
import ColoredStatus from "../../../components/ui/ColoredStatus";
import MarkedStatus from "../../../components/ui/MarkedStatus";
import SpeakerShortCard from "../../../components/speakers/SpeakerShortCard";
import SpeakersShortList from "../../../components/speakers/SpeakersShortList";
import AgendaVerificationForm from "../../../components/agenda/agenda-verification-form";
import AgendaAttendedButtons from "../../../components/agenda/agenda-attended-buttons";
import AgendaSchedulerButtons from "../../../components/agenda/agenda-schedule-buttons";
import AgendaScheduleButtonsMobile from "../../../components/agenda/agenda-schedule-buttons-mobile";
import { SESSION_STATUSES } from "../../../constants/messages";
import CoOccurringModal from "./co-occurring-modal";
import AgendaInfoModal from "./agenda-info-modal";

export default {
  components: {
    CoOccurringModal,
    AgendaInfoModal,
    AgendaApprovals,
    SpeakersShortList,
    ColoredStatus,
    MarkedStatus,
    SpeakerShortCard,
    AgendaVerificationForm,
    AgendaAttendedButtons,
    AgendaSchedulerButtons,
    AgendaScheduleButtonsMobile,
  },
  props: {
    allowAddToScheduler: {
      type: Boolean,
      default: true,
    },
    groupTimeFrame: {
      type: Boolean,
      default: false,
    },
    session: {
      type: Object,
      default: {},
    },
    showCeHoursOnMobile: {
      type: Boolean,
      default:false,
    },
    hiddenScheduleButton: {
      type: Boolean,
      default: false,

    },
    currentPage: {
      type: String,
      default: 'schedule'
    }
  },
  computed: {
    ...mapGetters('attendeeStore', ['attendee']),

    sessionStatuses() {
      return SESSION_STATUSES;
    },

    NOT_MEET() {
      return this.session.buttons?.evaluation?.threshold_failed
    },

    EVALUATION_EXPIRED() {
      return this.session.buttons?.evaluation?.expired
    },

    EVALUATION_EXPIRATION_DATE() {
      return this.session.buttons?.evaluation?.expiration_date
    },

    expirationBadgeTooltip() {
      return this.EVALUATION_EXPIRED
        ? this.sessionStatuses.EVALUATION_EXPIRED
        : 'Evaluation available until\n' + this.EVALUATION_EXPIRATION_DATE
    },

    noAnyStatus() {
      return !(this.session.not_registered_for && !this.session.is_agenda) && !this.session.buttons?.evaluation?.completed && !this.session.in_progress
    },
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      isOpen: false,
      showSchedulerIndicator: false,
      showAttendedIndicator: false,
      co_occurring: null,
      isAgendaInfoOpen: false,
    }
  },
  methods: {
    handleClickWholeItem() {
      if (this.currentPage === "Full Schedule") {
        this.$emit('setNavigationHistoryForSessionItem');
      }
      // if mobile click all card
      // if(window.innerWidth < 900){
      //   if(!this.session.is_agenda){
      //     this.$router.push({
      //       path: `/${this.attendeeId}/dash/agenda/sessions/${this.session.id}`,
      //       // query: {back: this.currentPage}
      //     });
      //   }
      // }
    },

    // Agenda items have no detail page, so the whole card opens the info modal
    // (the description is hidden on mobile and clamped on desktop).
    handleAgendaCardClick(event) {
      if (!this.session.is_agenda || event.target.closest('a, button')) {
        return;
      }

      this.isAgendaInfoOpen = true;
    },

    goTo(page, sessionId) {
      if (page === 'evaluation') {
        this.$router.push({name: "Session Evaluation", params: {sessionId: sessionId}, query: {back: this.$route.name}});
      } else if (page === 'quiz') {
        this.$router.push({name: "Session Quiz", params: {sessionId: sessionId}, query: {back: this.$route.name}});
      }
    },

    limitTo: (...arg) => {
      return limitTo(...arg);
    },

    updateScheduler(params = {}) {
      this.showSchedulerIndicator = true

      if (this.session?.buttons?.my_schedule?.completed) {
        agendaAPI.removeFromScheduler(this.attendeeId, this.session.id)
          .then(() => {
            this.session.buttons.my_schedule.completed = !this.session.buttons.my_schedule.completed;
            this.session.my_agenda = !this.session.my_agenda;

            this.$store.dispatch("agendaStore/updateFlatSessionById", {id: this.session.id, session: this.session});
            this.$store.dispatch('attendeeStore/updateMyAgendaCount', {count: -1});
          })
          .catch(() => {})
          .finally(() => {
            this.showSchedulerIndicator = false;
          });
      } else {
        agendaAPI.addToScheduler(this.attendeeId, this.session.id, params)
          .then(() => {
            this.co_occurring = null;
            this.session.buttons.my_schedule.completed = !this.session.buttons.my_schedule.completed;
            this.session.my_agenda = !this.session.my_agenda;

            this.$store.dispatch("agendaStore/updateFlatSessionById", {id: this.session.id, session: this.session});
            this.$store.dispatch('attendeeStore/updateMyAgendaCount', {count: 1});
          })
          .catch((error) => {
            if (error?.response?.status === 422) {
              this.co_occurring = error.response.data;
            }
          })
          .finally(() => {
            this.showSchedulerIndicator = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.agenda-footer__button--badged {
  position: relative;
}

.eval-expiration-badge {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e2544d;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  cursor: help;
  z-index: 2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
}

.agenda-footer-form {
  display: flex;
  gap: var(--attendee-gap-md);

  .agenda-footer-form-button {
    margin-top: 27px;
  }
}

.agenda-footer {
  display: flex;
  gap: var(--attendee-gap-sm);
  align-items: flex-end;
  justify-content: space-between;


  &--single-session {
    justify-content: flex-end;
  }

  &__wrapper {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
  }

  @media (max-width: 900px) {
    display: none;
  }

  &__button {
    margin-bottom: var(--attendee-gap-sm);
  }
}

.join-button {
  margin-top: 30px;
}

.agenda-item {
  border: 1px solid var(--attendee-border-color);
  background-color: var(--attendee-card-color);
  border-radius: var(--attendee-card-border-radius);
  margin-bottom: var(--attendee-gap-lg);
  display: grid;
  transition: .3s all;
  position: relative;

  @media (max-width: 900px) {
    border: none;
    margin-bottom:0;
  }

  &--clickable {
    cursor: pointer;
  }

  &__title-button {
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid var(--attendee-brand-color);
      outline-offset: 2px;
    }
  }

  &.hideDateForMobile {
    .agenda-item__header {
      @media (max-width: 900px) {
        display: none;
      }
    }
  }

  // якщо немає
  &:not(.hideDateForMobile){
    .agenda-scheduler-buttons-mobile {

      &.up-if-no-status {
        @media (max-width: 900px) {
          margin-top: -36px !important;
        }
      }
    }
  }

  .font-weight-600 {
    font-weight: 600;
  }

  .agenda-mobile-track {
    display: none;

    @media (max-width: 900px) {
      width: 10px;
      display: inline-block;
      min-width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }

  &__notify {
    position: absolute;
    right: -8px;
    z-index: 3;
    top: 0;
    background-color: #f66;
    border-radius: 15px;
    color: #fff;
    font-size: 12px;
    height: 15px;
    justify-content: center;
    min-width: 15px;
    padding: 0 4px;
    align-items: center;
    display: flex
  }

  &__info {
    color: var(--attendee-text-primary-color);

    @media (max-width: 900px) {
      display: none;
    }
  }


  &__status {
    max-width: 167px;
  }

  .agenda-mobile-line {
    @media (max-width: 900px) {
      background-color: var(--attendee-border-color);
      height: 1px;
      width: 100%;
      margin-top: var(--attendee-gap-sm);
      margin-bottom: var(--attendee-gap-sm);
    }
  }

  &__body {
    padding: var(--attendee-gap-md) var(--attendee-gap-md) var(--attendee-gap-sm) var(--attendee-gap-md);
    width: 100%;
    min-width: 1px;

    @media (max-width: 900px) {
      padding: 0;
    }
  }

  &__header {
    background-color: var(--attendee-background-color);
    border-top-right-radius: var(--attendee-card-border-radius);
    border-top-left-radius: var(--attendee-card-border-radius);
    padding: var(--attendee-gap-sm) var(--attendee-gap-md);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__time {
    color: var(--attendee-text-primary-color);
    gap: 10px;
    align-items: center;
    letter-spacing: 0;
  }

  &__title {
    cursor: pointer;
    font-size: 19px;
    line-height: 28px;
    color: var(--attendee-brand-color);
    margin-bottom: var(--attendee-gap-md);
    display: grid;
    justify-content: space-between;
    align-items: center;
    grid-gap: 10px;
    grid-template-columns: auto auto;

    @media (max-width: 900px) {
      margin-bottom: 0;
      padding: 0 var(--attendee-gap-md);
    }

    .agenda-scheduler-buttons-mobile{
      display: none;

      @media (max-width: 900px) {
        display: block;
        position: relative;
        z-index: 3;
      }
    }

    a {
      font-weight: 400;
      font-size: inherit;

      @media (max-width: 900px) {
        font-size: 16px;
      }
    }

    svg {
      margin-right: 5px;
    }
  }

  &__short-description {
    color: var(--attendee-text-secondary-color);
    font-size: 16px;
    margin-bottom: var(--attendee-gap-sm);
    margin-top: -12px;

    @media (max-width: 900px) {
      margin-top: 0;
      margin-left: var(--attendee-gap-md);
      padding-right: var(--attendee-gap-md);
    }
  }

  &__description {
    color: var(--attendee-text-primary-color);
    font-size: 16px;
    margin: var(--attendee-gap-sm) 0 var(--attendee-gap-md);
  }

  .agenda-item-info-item {
    margin-bottom: var(--attendee-gap-sm);
    font-size: 16px;
    color: var(--attendee-text-primary-color);

    @media (max-width: 900px) {
      display: none;
    }

    &.showCEOnMobile {
      @media (max-width: 900px) {
        display: block;
        margin-left: var(--attendee-gap-md);
      }
    }

    strong {
      font-size: 16px;
    }

    svg {
      margin-right: 5px;
    }
  }
}
</style>
